import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { Grid, GridColumn } from 'telia-front-react';

interface InternetPacketSpeedProps {
  download?: string;
  upload?: string;
}

const InternetPacketSpeed: React.FC<InternetPacketSpeedProps> = (props) => {
  const { translate } = useContext(TranslationsContext);
  const { download, upload } = props;

  if (download && !upload) {
    return (
      <div>
        <p className="text__margin-double">{translate('internetPacketItem.downloadUpload')}</p>
        <p className="h3 text-bold text__margin-none">{download}</p>
      </div>
    );
  }
  return (
    <Grid align={['center-md']}>
      <GridColumn width={['xs']}>
        <div>
          {translate('internetPacketItem.download')}
          <h3 className="text-bold">{download}</h3>
        </div>
      </GridColumn>
      <GridColumn width={['xs']}>
        <div>
          {translate('internetPacketItem.upload')}
          <h3 className="text-bold">{upload}</h3>
        </div>
      </GridColumn>
    </Grid>
  );
};

export default InternetPacketSpeed;
